/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Division_In_UseInputs */

const th_err_division_in_use = /** @type {(inputs: Err_Division_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มีทีมลงทะเบียนในดิวิชั่นนั้นแล้ว จึงไม่สามารถลบได้`)
};

const en_err_division_in_use = /** @type {(inputs: Err_Division_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams are registered in that division, so it cannot be removed.`)
};

const ja_err_division_in_use = /** @type {(inputs: Err_Division_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`そのディビジョンにはチームが登録されているため、削除できません。`)
};

const zh_err_division_in_use = /** @type {(inputs: Err_Division_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此分区已有球队报名，无法删除。`)
};

const es_err_division_in_use = /** @type {(inputs: Err_Division_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hay equipos inscritos en esa categoría, así que no se puede eliminar.`)
};

const pt_err_division_in_use = /** @type {(inputs: Err_Division_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há times inscritos nessa categoria, então ela não pode ser removida.`)
};

const id_err_division_in_use = /** @type {(inputs: Err_Division_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisi ini punya tim yang terdaftar, jadi tidak bisa dihapus.`)
};

const fr_err_division_in_use = /** @type {(inputs: Err_Division_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des équipes sont inscrites dans cette catégorie, elle ne peut donc pas être supprimée.`)
};

const tl_err_division_in_use = /** @type {(inputs: Err_Division_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`May mga team na nakarehistro sa dibisyong ito, kaya hindi ito maaaring alisin.`)
};

const vi_err_division_in_use = /** @type {(inputs: Err_Division_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bảng này đang có đội đăng ký, nên không thể xoá.`)
};

const ko_err_division_in_use = /** @type {(inputs: Err_Division_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 디비전에 등록된 팀이 있어 삭제할 수 없습니다.`)
};

const de_err_division_in_use = /** @type {(inputs: Err_Division_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In dieser Klasse sind Teams gemeldet, sie lässt sich deshalb nicht entfernen.`)
};

const ru_err_division_in_use = /** @type {(inputs: Err_Division_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В этом дивизионе есть заявленные команды, поэтому его нельзя удалить.`)
};

const tr_err_division_in_use = /** @type {(inputs: Err_Division_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu grupta kayıtlı takımlar var, bu yüzden kaldırılamaz.`)
};

const it_err_division_in_use = /** @type {(inputs: Err_Division_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa categoria ha squadre iscritte, quindi non può essere rimossa.`)
};

const pl_err_division_in_use = /** @type {(inputs: Err_Division_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`W tej grupie są zgłoszone drużyny, więc nie można jej usunąć.`)
};

const uk_err_division_in_use = /** @type {(inputs: Err_Division_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У цьому дивізіоні є заявлені команди, тож його не можна видалити.`)
};

const hi_err_division_in_use = /** @type {(inputs: Err_Division_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस वर्ग में टीमें पंजीकृत हैं, इसलिए इसे हटाया नहीं जा सकता।`)
};

const ar_err_division_in_use = /** @type {(inputs: Err_Division_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`في هذه الفئة فرق مسجَّلة، لذا لا يمكن حذفها.`)
};

const ms_err_division_in_use = /** @type {(inputs: Err_Division_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisyen ini mempunyai pasukan berdaftar, jadi ia tidak boleh dibuang.`)
};

const bn_err_division_in_use = /** @type {(inputs: Err_Division_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই বিভাগে নিবন্ধিত দল আছে, তাই এটি সরানো যাবে না।`)
};

const zh_tw2_err_division_in_use = /** @type {(inputs: Err_Division_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個分組已有球隊報名，因此無法移除。`)
};

const zh_hk2_err_division_in_use = /** @type {(inputs: Err_Division_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個組別已有球隊報名，因此無法移除。`)
};

const ur_err_division_in_use = /** @type {(inputs: Err_Division_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اس درجے میں رجسٹرڈ ٹیمیں ہیں، اس لیے اسے ہٹایا نہیں جا سکتا۔`)
};

const fa_err_division_in_use = /** @type {(inputs: Err_Division_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`در این گروه تیم ثبت‌شده وجود دارد، پس نمی‌توان آن را حذف کرد.`)
};

const sw_err_division_in_use = /** @type {(inputs: Err_Division_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daraja hili lina timu zilizosajiliwa, kwa hivyo haliwezi kuondolewa.`)
};

const nl_err_division_in_use = /** @type {(inputs: Err_Division_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze klasse heeft ingeschreven teams en kan daarom niet worden verwijderd.`)
};

/**
* | output |
* | --- |
* | "Teams are registered in that division, so it cannot be removed." |
*
* @param {Err_Division_In_UseInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_division_in_use = /** @type {((inputs?: Err_Division_In_UseInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Division_In_UseInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_err_division_in_use(inputs)
	if (locale === "ja") return ja_err_division_in_use(inputs)
	if (locale === "zh") return zh_err_division_in_use(inputs)
	if (locale === "es") return es_err_division_in_use(inputs)
	if (locale === "pt") return pt_err_division_in_use(inputs)
	if (locale === "id") return id_err_division_in_use(inputs)
	if (locale === "fr") return fr_err_division_in_use(inputs)
	if (locale === "tl") return tl_err_division_in_use(inputs)
	if (locale === "vi") return vi_err_division_in_use(inputs)
	if (locale === "ko") return ko_err_division_in_use(inputs)
	if (locale === "de") return de_err_division_in_use(inputs)
	if (locale === "ru") return ru_err_division_in_use(inputs)
	if (locale === "tr") return tr_err_division_in_use(inputs)
	if (locale === "it") return it_err_division_in_use(inputs)
	if (locale === "pl") return pl_err_division_in_use(inputs)
	if (locale === "uk") return uk_err_division_in_use(inputs)
	if (locale === "hi") return hi_err_division_in_use(inputs)
	if (locale === "ar") return ar_err_division_in_use(inputs)
	if (locale === "ms") return ms_err_division_in_use(inputs)
	if (locale === "bn") return bn_err_division_in_use(inputs)
	if (locale === "zh-TW") return zh_tw2_err_division_in_use(inputs)
	if (locale === "zh-HK") return zh_hk2_err_division_in_use(inputs)
	if (locale === "ur") return ur_err_division_in_use(inputs)
	if (locale === "fa") return fa_err_division_in_use(inputs)
	if (locale === "sw") return sw_err_division_in_use(inputs)
	if (locale === "nl") return nl_err_division_in_use(inputs)
	return en_err_division_in_use(inputs)
});